import React from "react";
import { Container, Row, Col, Image, Table } from "react-bootstrap";

import BannerImg from "../assets/images/team.svg";
import Faculty from "./Faculty";
import Lab from "./Lab";

// import "./GmbGeoGrid.css";

const Department = () => {
  return (
    <><Faculty/>
      <Lab/>
</>
  















    // <div className="review-management">
    //   <div className="review-banner section_padding">
      //   {/* <Container>
      //     <Row className="align-items-center justify-content-between">
      //       <Col md={5} sm={12}>
      //         <h1 className="banner-head text-primary font-weight-bold">
      //           BIT Sindri Civil Engineering
      //         </h1>
      //         <p className="banner-text">Department Details</p>
      //       </Col>
      //       <Col md={6} sm={12}>
      //         <Image src={BannerImg} className="img-fluid" />
      //       </Col>
      //     </Row>
      //   </Container>
      // </div>
      // <div className="section_padiing">
      //   <Container>
      //     <Row>
      //       <Col md={12}>
      //         <Table striped bordered hover>
      //           <thead>
      //             <tr>
      //               <th>#</th>
      //               <th>Professor Name </th>
      //               <th>Designation</th>
      //             </tr>
      //           </thead>
      //           <tbody>
      //             <tr>
      //               <td>1</td>
      //               <td>Dr. Ranvijay Singh</td>
      //               <td>HoD & Professor</td>
      //             </tr>
      //             <tr>
      //               <td>2</td>
      //               <td>Dr. Vikrama Pandey</td>
      //               <td>Professor</td>
      //             </tr>
      //             <tr>
      //               <td>3</td>
      //               <td>Dr. U.K. Singh</td>
      //               <td>Professor</td>
      //             </tr>
      //             <tr>
      //               <td>4</td>
      //               <td>Dr. Jitu Kujur</td>
      //               <td>Associate Professor</td>
      //             </tr>
      //             <tr>
      //               <td>5</td>
      //               <td>Prof. Ajit Kumar Singh</td>
      //               <td>Associate Professor</td>
      //             </tr>
      //             <tr>
      //               <td>6</td>
      //               <td>Prof. Chitranjan Sharma</td>
      //               <td>Associate Professor</td>
      //             </tr>
      //             <tr>
      //               <td>7</td>
      //               <td>Prof. J.P. Singh</td>
      //               <td>Associate Professor</td>
      //             </tr>
      //             <tr>
      //               <td>8</td>
      //               <td>Prof. Krishna Murari</td>
      //               <td>Associate Professor</td>
      //             </tr>
      //             <tr>
      //               <td>9</td>
      //               <td>Dr. Nishikant Kisku</td>
      //               <td>Assistant Professor</td>
      //             </tr>
      //             <tr>
      //               <td>10</td>
      //               <td>Prof. P.K Sharma</td>
      //               <td>Assistant Professor</td>
      //             </tr>
      //             <tr>
      //               <td>11</td>
      //               <td>Prof. Sheo Kumar</td>
      //               <td>Assistant Professor</td>
      //             </tr>
      //             <tr>
      //               <td>12</td>
      //               <td>Prof. Shyam Kishor Kumar</td>
      //               <td>Assistant Professor</td>
      //             </tr>
      //             <tr>
      //               <td>13</td>
      //               <td>Mr. Abhijit Anand</td>
      //               <td>Assistant Professor</td>
      //             </tr>
      //             <tr>
      //               <td>14</td>
      //               <td>Mr. Rabindra Kumar</td>
      //               <td>Assistant Professor</td>
      //             </tr>
      //             <tr>
      //               <td>15</td>
      //               <td>Ms. Sudha Das Khan</td>
      //               <td>Assistant Professor</td>
      //             </tr>
      //             <tr>
      //               <td>16</td>
      //               <td>Iqbal Sheikh</td>
      //               <td>Assistant Professor</td>
      //             </tr>
      //             <tr>
      //               <td>17</td>
      //               <td>Saroj Meena</td>
      //               <td>Assistant Professor</td>
      //             </tr>
      //             <tr>
      //               <td>18</td>
      //               <td>Prashant Malviya</td>
      //               <td>Assistant Professor</td>
      //             </tr>
      //           </tbody>
      //         </Table>
      //       </Col>
      //     </Row>
      //   </Container> */}

    //   </div>
    // </div>
  );
};

export default Department;
